import React, { useEffect, useState } from "react";
import { TrendingUp, X } from "lucide-react";

const names = ["Brittany", "Marcus", "Tanya", "Devon", "Jasmine", "Tyler", "Aisha", "Roberto", "Kelly", "Andre", "Lashonda", "Pedro"];
const cities = ["Cincinnati, OH", "Sacramento, CA", "Atlanta, GA", "Detroit, MI", "Houston, TX", "Newark, NJ", "Charlotte, NC", "Phoenix, AZ", "Indianapolis, IN"];
const bureaus = ["TransUnion", "Equifax", "Experian"];
const events = [
  (name, city, n, bureau) => `${name} from ${city} score just increased ${n} points on ${bureau}`,
  (name, city) => `${name} from ${city} just joined Knight Credit Consultants`,
  (name, city, n, bureau) => `${name} from ${city} got a collection removed on ${bureau}`,
  (name) => `${name} just scheduled a free consultation`,
];

const rand = (a) => a[Math.floor(Math.random() * a.length)];

const LiveTicker = () => {
  const [msg, setMsg] = useState(null);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (closed) return;
    let timeout, interval;
    const fire = () => {
      const name = rand(names);
      const city = rand(cities);
      const bureau = rand(bureaus);
      const points = 40 + Math.floor(Math.random() * 140);
      const fn = rand(events);
      setMsg({ text: fn(name, city, points, bureau), key: Date.now() });
      timeout = setTimeout(() => setMsg(null), 6500);
    };
    timeout = setTimeout(fire, 4000);
    interval = setInterval(fire, 11000);
    return () => { clearTimeout(timeout); clearInterval(interval); };
  }, [closed]);

  if (!msg || closed) return null;
  return (
    <div
      key={msg.key}
      className="fixed bottom-5 left-5 z-40 max-w-xs bg-white border border-slate-200 shadow-2xl rounded-2xl p-3 pr-9 flex items-center gap-3 animate-[slideIn_0.5s_ease-out]"
      style={{ animationName: "slideIn" }}
    >
      <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0">
        <TrendingUp size={18} />
      </div>
      <div className="min-w-0">
        <p className="text-[13px] font-semibold text-knight-navy leading-snug">{msg.text}</p>
        <p className="text-[10px] text-knight-navy/50 mt-0.5">just now</p>
      </div>
      <button onClick={() => setClosed(true)} className="absolute top-2 right-2 text-knight-navy/40 hover:text-knight-navy" aria-label="Close">
        <X size={14} />
      </button>
    </div>
  );
};

export default LiveTicker;
